import { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import RegisterCustomerForm from './RegisterCustomerForm';
import RegisterCustomerVerificationForm from './RegisterCustomerVerificationForm';
import { ReactComponent as Logo } from '../../images/logo.svg';
import { useHistory } from 'react-router-dom';
import './RegisterCustomer.scss';
import { PublicRoutesEnum } from '../../core/enums';
import { getClientForAmazonConnect } from '../../core/api';
import { Loader } from '../../components/Loader/Loader';
import { useAppDispatch } from '../../hooks';

const HEADER_BLOCK_KEY = 'header';

interface Props {
  initialVerification?: boolean;
  initialEmail?: string;
  initialPassword?: string;
}

export default function RegisterCustomer({
  initialVerification = false,
  initialEmail = '',
  initialPassword = '',
}: Props) {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);
  const state = params.get('state');
  const [isLoading, setIsLoading] = useState(!initialVerification);
  const [password, setPassword] = useState(initialPassword);
  const [email, setEmail] = useState(initialEmail);
  const [isVerification, setIsVerification] = useState(initialVerification);
  const [isError, setIsError] = useState(false);

  const onRegisterSubmit = (email: string, password: string) => {
    setEmail(email);
    setPassword(password);
    setIsVerification(true);
  };

  useEffect(() => {
    if (state) {
      getClientForAmazonConnect(state)
        .then(() => {
          setIsLoading(false);
        })
        .catch((e) => {
          setIsLoading(false);
          if (e.response.status === 400) {
            setIsError(true);
            history.push(PublicRoutesEnum.Page404);
          }
        });
    }
  }, [dispatch, history, state]);

  useEffect(() => {
    if (!isVerification && !state) {
      history.push(PublicRoutesEnum.Page404);
    }
  }, [state, history, isVerification]);

  if (!isVerification && !state) {
    return null;
  }

  if (isLoading) return <Loader />;
  if (isError) return null;

  return (
    <div className='RegisterCustomer d-flex flex-column'>
      <Header blockKey={HEADER_BLOCK_KEY} />
      <div className='pt-4 mt-2 d-flex justify-content-center align-items-start flex-grow-1 px-3'>
        <div className='RegisterCustomer__card RegisterCustomer__tile'>
          <div className='text-center Text'>
            <div className='mb-3 mb-lg-4'>
              <Logo className='RegisterCustomer__logo' />
            </div>
          </div>
          {isVerification ? (
            <RegisterCustomerVerificationForm
              email={email}
              password={password}
            />
          ) : (
            <RegisterCustomerForm
              onSubmit={onRegisterSubmit}
              uuid={state || ''}
            />
          )}
        </div>
      </div>
    </div>
  );
}
